import { render, staticRenderFns } from "./Leave.vue?vue&type=template&id=338b1efb&scoped=true"
import script from "./Leave.vue?vue&type=script&lang=js"
export * from "./Leave.vue?vue&type=script&lang=js"
import style0 from "./Leave.vue?vue&type=style&index=0&id=338b1efb&prod&scoped=scoped&lang=less"
import style1 from "./Leave.vue?vue&type=style&index=1&id=338b1efb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338b1efb",
  null
  
)

export default component.exports